/**
 * 结构专业的信号
 */

export const STRUCTURE_SIGNAL = {
    initSBeamControl: "initSBeamControl", // 初始化结构梁控制器
    initSColumnControl: "initSColumnControl", // 初始化结构控制器
    initSBarControl: "initSBarControl", // 初始化结构杆控制器
    initSBraceControl: "initSBraceControl", // 初始化结构支撑控制器
    initSWallControl: "initSWallControl", // 初始化结构墙控制器
    initSFloorControl: "initSFloorControl", // 初始化结构板控制器
}